import React from 'react';
export function GuaranteeSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-57">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58">
        <img src="https://cdn.magicpatterns.com/uploads/brqUmSz4yCe5C97rvxKRZm/garantia_de_7_dias.jpg" alt="Garantía de 7 días" className="w-32 h-32 mx-auto mb-4 object-contain" data-id="element-59" />

        <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3" data-id="element-60">
          Garantía de satisfacción de 7 días
        </h2>

        <div className="max-w-2xl mx-auto text-lg text-gray-700 space-y-3" data-id="element-61">
          <p className="font-medium" data-id="element-62">
            Queremos que estés 100% conforme con tu compra.
          </p>
          <p data-id="element-63">
            Probalo sin riesgo. Si no te resulta útil, podés pedir la devolución
          </p>
          <p className="font-semibold text-gray-900" data-id="element-64">
            Comprá con total tranquilidad: tu inversión está protegida.
          </p>
        </div>
      </div>
    </section>;
}